import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { TabContent } from '../Tab.Content';
import * as styles from './Tab.Group.scss';
export var TabGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(TabGroup, _React$Component);

  var _super = _createSuper(TabGroup);

  function TabGroup(props) {
    var _this;

    _classCallCheck(this, TabGroup);

    _this = _super.call(this, props);

    _this.onTabClicked = function (tabIndexClicked) {
      _this.setState({
        activeTabIndex: tabIndexClicked
      });

      if (_this.props.onTabIndexChanged) {
        _this.props.onTabIndexChanged(tabIndexClicked);
      }
    };

    _this.state = {
      activeTabIndex: props.activeTabIndex
    };
    return _this;
  }

  _createClass(TabGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", null, React.createElement("nav", {
        role: "tablist",
        "data-test": this.props.dataTest,
        className: styles.tabGroupContainer
      }, React.Children.map(this.props.children, function (child, index) {
        return child ? React.cloneElement(child, {
          activeTabIndex: _this2.state.activeTabIndex,
          key: index,
          index: index,
          numTabsInGroup: React.Children.count(_this2.props.children),
          onTabClicked: function onTabClicked(tabIndexClicked) {
            return _this2.onTabClicked(tabIndexClicked);
          }
        }) : null;
      }), React.createElement("div", {
        className: styles.tabNavShadowContainer
      }, React.createElement("div", {
        className: styles.tabNavShadow
      }))), React.Children.map(this.props.children, function (child, index) {
        var childRef = child;
        return childRef && React.createElement(TabContent, {
          active: _this2.state.activeTabIndex === index
        }, childRef.props.children);
      }));
    }
  }]);

  return TabGroup;
}(React.Component);